import { createRepositoryWithLocalstorage } from './tokenRepository';
import { createClient } from './apiClientSetup';

export const tokenRepository = createRepositoryWithLocalstorage();
export const apiClient = createClient({ tokenRepository });
